import React from 'react';

export default function TextLengthFilter({ value, onApply }) {
  const [minimum, setMinimum] = React.useState(value.min);
  const [maximum, setMaximum] = React.useState(value.max);
  const invalid = minimum !== '' && maximum !== '' && Number(minimum) > Number(maximum);
  return (
    <form onSubmit={(event) => { event.preventDefault(); if (!invalid) onApply({ min: minimum, max: maximum }); }} style={{ display: 'flex', alignItems: 'end', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
      <label>Длина текста от, символов
        <input className="form-control" type="number" min="0" step="1" placeholder="Без ограничения" value={minimum} onChange={(event) => setMinimum(event.target.value)} />
      </label>
      <label>Длина текста до, символов
        <input className="form-control" type="number" min="0" step="1" placeholder="Без ограничения" value={maximum} onChange={(event) => setMaximum(event.target.value)} />
      </label>
      <button className="btn btn-primary" type="submit" disabled={invalid}>Применить</button>
      <button className="btn btn-outline-secondary" type="button" onClick={() => { setMinimum(''); setMaximum(''); onApply({ min: '', max: '' }); }}>Сбросить</button>
      {invalid && <span role="alert" className="text-danger">Минимум не должен превышать максимум</span>}
    </form>
  );
}
